import { getDefaultPath } from "../../helpers/urlSync";
import actions, { getView } from "./actions";
import {PAGE_STATUS} from 'common/enum';

const preKeys = getDefaultPath();

const initState = {
  collapsed: window.innerWidth > 1220 ? false : true,
  view: getView(window.innerWidth),
  height: window.innerHeight,
  openDrawer: false,
  openKeys: preKeys,
  current: preKeys,

  pageStatus : PAGE_STATUS.NUN,
  toasts : []
};

export default function appReducer(state = initState, action) {

  switch (action.type) {
    case actions.COLLPSE_CHANGE:
      return {
        ...state,
        collapsed: !state.collapsed
      };
    case actions.COLLPSE_OPEN_DRAWER:
      return {
        ...state,
        openDrawer: !state.openDrawer
      };
    case actions.TOGGLE_ALL:
      if (state.view !== action.view || action.height !== state.height) {
        const height = action.height ? action.height : state.height;
        return {
          ...state,
          collapsed: action.collapsed,
          view: action.view,
          height
        };
      }
      break;
    case actions.CHANGE_OPEN_KEYS:
      return {
        ...state,
        openKeys: action.openKeys
      };
    case actions.CHANGE_CURRENT:
      return {
        ...state,
        current: action.current
      };
    case actions.CLEAR_MENU:
      return {
        ...state,
        openKeys: [],
        current: []
      };


      case actions.CLEAR_TOAST:
      return {
        ...state,
        toasts : []
      };
      case actions.ADD_TOAST:{
        const {payload} = action;
        let tl = state.toasts;
        tl[payload.toast.key](payload.toast);
        return {
          ...state,
          toasts: tl
        };
      }
      case actions.REMOVE_TOAST:{
        const {payload} = action;
        let tl = state.toasts;
        delete tl[payload.key];
        return {
          ...state,
          toasts: tl
        };
      }
    default:
      return state;
  }
  return state;
}
